import { useEffect } from "react";

import {
  usePairedIntersectionObserver,
  useUnmountBrandTileContext,
} from "./__internal__/BrandTileImpressionContexts";

export const useBrandTileViewImpression = ({
  brandToken = "",
  impressionId = "",
}: {
  brandToken?: string;
  impressionId?: string;
}) => {
  const handleIntersectionObserverCallbackRef = usePairedIntersectionObserver();
  const { onUnmount } = useUnmountBrandTileContext();

  useEffect(() => {
    return () => {
      onUnmount?.(brandToken, impressionId);
    };
  }, [brandToken, impressionId, onUnmount]);

  return {
    ref: handleIntersectionObserverCallbackRef,
    "data-brand-impression-id": impressionId,
    "data-brand-token": brandToken,
  };
};
